<template>
  <el-table-column
    prop="third_copy_receive_date"
    sortable="custom"
    label="Harmadik másolat beérk."
  >
    <template slot-scope="scope">
      {{ scope.row.third_copy_receive_date }} <span v-if="scope.row.third_copy_creator_user_name">({{ scope.row.third_copy_creator_user_name }})</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'representativeUser.last_name',
};
</script>
